var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"shareIconPath","d":"M108.213 19.6329C111.891 25.9752 109.709 34.0852 103.339 37.7469C98.3168 40.6347 92.1915 39.8955 88.0217 36.345L44.5146 61.356C44.7084 62.7503 44.681 64.1791 44.4176 65.5896L88.0215 90.6555C92.1912 87.1051 98.3168 86.3658 103.339 89.2526C109.709 92.9143 111.891 101.024 108.213 107.368C104.536 113.71 96.3905 115.883 90.0206 112.221C84.9987 109.334 82.5793 103.682 83.5824 98.3112L39.9788 73.2452C35.809 76.7957 29.6835 77.536 24.6613 74.6481C18.2914 70.9865 16.1088 62.8765 19.7865 56.5342C23.4642 50.1908 31.6095 48.0185 37.9794 51.6801C38.8844 52.2003 39.7049 52.81 40.4362 53.492L83.5826 28.6894C82.5793 23.3183 84.9984 17.6656 90.0206 14.7788C96.3905 11.1172 104.536 13.2896 108.213 19.6329Z","fill":"white"}));
}

Share.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = Share;

Share.default = Share;
